module.exports = fox._r("images/loader.gif", __webpack_public_path__ + "images/loader.gif");


//////////////////
// WEBPACK FOOTER
// ./images/loader.gif
// module id = 78
// module chunks = 4